import { render, staticRenderFns } from "./blogPreviewComponent.vue?vue&type=template&id=89f38be6&scoped=true&"
import script from "./blogPreviewComponent.vue?vue&type=script&lang=ts&"
export * from "./blogPreviewComponent.vue?vue&type=script&lang=ts&"
import style0 from "./blogPreviewComponent.vue?vue&type=style&index=0&id=89f38be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f38be6",
  null
  
)

export default component.exports